import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import {
  Button, ButtonSizes, ButtonTypes, ButtonAppearance,
  Badge,
} from '@leegality/leegality-react-component-library';
import useTranslation from '../../../utils/translation-utils';
import IconWrapper from '../icon-wrapper';

const ButtonWrapper = React.forwardRef(({
  id, label, type, icon, size, disabled, onClick, className, title, borderLess, appearance, loading,
  badgeProps, testIds, ariaLabel,
}, ref) => {
  const [getTranslation] = useTranslation();
  const onClickCallback = useCallback(() => onClick(id), [id, onClick]);

  const renderIcon = (iconProps) => (
    <IconWrapper icon={icon} size={iconProps.size} color={iconProps.color} />
  );

  return (
    <Button
      label={getTranslation(label)}
      type={type}
      renderIcon={icon ? renderIcon : null}
      size={size}
      disabled={disabled}
      onClick={onClickCallback}
      className={className}
      title={title}
      borderLess={borderLess}
      appearance={appearance}
      ref={ref}
      loading={loading}
      badgeProps={badgeProps}
      testIds={testIds}
      ariaLabel={ariaLabel}
    />
  );
});

ButtonWrapper.propTypes = {
  id: PropTypes.string,
  label: PropTypes.string,
  title: PropTypes.string,
  type: PropTypes.oneOf(Object.values(ButtonTypes)),
  size: PropTypes.oneOf(Object.values(ButtonSizes)),
  icon: PropTypes.oneOfType([PropTypes.element, PropTypes.elementType,
    PropTypes.func, PropTypes.oneOf([null])]),
  disabled: PropTypes.bool,
  className: PropTypes.string,
  onClick: PropTypes.func,
  borderLess: PropTypes.bool,
  appearance: PropTypes.oneOf(Object.values(ButtonAppearance)),
  loading: PropTypes.bool,
  badgeProps: PropTypes.shape({ ...Badge.propTypes }),
  testIds: PropTypes.shape({}),
  ariaLabel: PropTypes.string,
};

ButtonWrapper.defaultProps = {
  id: '',
  label: '',
  title: '',
  type: ButtonTypes.PRIMARY,
  size: ButtonSizes.SMALL,
  icon: null,
  className: '',
  disabled: false,
  borderLess: false,
  onClick: () => {},
  appearance: ButtonAppearance.DEFAULT,
  loading: false,
  badgeProps: Badge.defaultProps,
  testIds: {},
  ariaLabel: undefined,
};

export {
  ButtonWrapper as default,
  ButtonTypes,
  ButtonSizes,
  ButtonAppearance,
};
